export const gridViewData = {
  availability: 'InStock',
  returnPolicy: 'MerchantReturnFiniteReturnWindow',
  merchantReturnLink: 'https://withjoy.com/help/en/articles/9275221-easy-returns',
  shippingDetailsLink: 'https://help.withjoy.com/baby-registry/free-shipping',
  shippingDestination: 'US',
  shippingRate: '0.00',
  shippingRateText: 'for orders over $45',
  productPhotoAlt: 'Registry Item',
  currency: 'USD',
} as const;
